/* eslint-disable max-len */
/* eslint-disable no-unused-expressions */
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  useFormik,
} from 'formik';
import * as yup from 'yup';
import {
  Typography,
  Autocomplete,
  Grid,
  TextField,
  FormControl,
  Button,
  MenuItem,
  CircularProgress,
  Switch,
  IconButton,
} from '@mui/material';
import { Clear } from '@mui/icons-material';
import { grey } from '@mui/material/colors';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { cloneDeep, concat } from 'lodash';
import { format } from 'date-fns';
import {
  useCompanyInfoLazyQuery,
  useGetCompanyManagerListLazyQuery,
  useCreateProjectMutation,
  useUpdateProjectMutation,
  useCompanyListLazyQuery,
} from '../../../../../../graphql/generated/graphql';

import { useLoginState } from '../../../../../hooks/loginInfo';
import usePrompt from "../../../../../hooks/usePrompt";
import { CompanyIInfo, CompanyManager, NewProjectForm } from '../../../../../config/interfaces';
import { setCompanyInfo, useCompanyInfoState } from '../../../../../hooks/companyInfo';
import Avatar from '../../../../components/avatar';
import { UserRoles } from '../../../../../config/enums';
import config from '../../../../../config/config';
import { LogoCompanySVG } from '../../../../../assets/svg';
import AddLogoCompany from '../../../../components/company/add-logo';
import { getBase64 } from '../../../../../helper/images';
import { setAlertDescription } from '../../../../../hooks/actions';

const formatDate = 'yyyy-MM-dd';
const { ID_MY_PROJECT: myProject } = config;

const ViewProjectPage = (_props: any) => {
  const {
    company: companyProp,
    projectId,
    urlLogo,
    projectName,
    startDate,
    endDate,
    numProject,
    companyManagers: companyManagersProps,
    lineProducer: lineProducerProps,
    productionCoordinator: productionCoordinatorProps,
    officePa: officePaProps,
    edit,
  } = _props;
  const navigate = useNavigate();
  const loginState = useLoginState();
  const companyState = useCompanyInfoState();
  const [image, setImage] = useState(urlLogo ? <img className="image-logo" src={urlLogo} alt="logo" /> : <LogoCompanySVG />);
  const [labelButton] = useState<string>(edit ? 'Save Project' : 'Create Project');
  const [areCompanyManager, setAreCompanyManager] = useState(false);
  const [companyId, setCompanyId] = useState(companyProp === null ? 'null' : companyProp?.id || loginState.company_id.get());
  const [getCompanyList, { data: companyList }] = useCompanyListLazyQuery();
  const [getCompanyManager, { data: listCompanyManagers }] = useGetCompanyManagerListLazyQuery();
  const [companyInfo, { data: company }] = useCompanyInfoLazyQuery({
    variables: {
      company_id: companyId === 'null' ? '' : companyId as string,
    },
  });
  const [editLogo, setEditLogo] = useState(false);
  const [changeCompany, setChangeCompany] = useState(false);
  const [companyManagers, setCompanyManagers] = useState<CompanyManager[]>(
    edit
      ? companyManagersProps
      : companyState.get().company_managers,
  );
  const [createProject] = useCreateProjectMutation();
  const [updateProject] = useUpdateProjectMutation();

  const [options, setOptions] = useState<CompanyManager[]>([]);
  const [optionsCompanyList, setOptionsCompanyList] = useState<CompanyIInfo[]>([]);

  const [openLineProducer, setOpenLineProducer] = useState(false);
  const [openProductionCoordinator, setOpenProductionCoordinator] = useState(false);
  const [openOfficePa, setOpenOfficePa] = useState(false);
  const [openCompany, setOpenCompany] = useState(false);

  const [valueAutoLine, setValueAutoLine] = useState<CompanyManager | null | undefined>();
  const [valueAutoProduction, setValueAutoProduction] = useState<CompanyManager | null | undefined>();
  const [valueAutoOffice, setValueAutoOffice] = useState<CompanyManager | null | undefined>();
  const [valueCompany, setValueCompany] = useState<CompanyIInfo | null | undefined>(
    () => {
      if (edit) {
        if (companyProp) {
          return { id: companyProp.id, company_name: companyProp.company_name, email: companyProp.email } as CompanyIInfo
        } else {
          return { id: 'null', company_name: 'My Project', email: 'MyProject@gmail.com' } as CompanyIInfo
        }
      }
      return null
    }
  );

  const [unsavedFlag, setUnsavedFlag] = useState(false);

  const [lineProducer, setLineProducer] = useState<CompanyManager | null | undefined>(lineProducerProps);
  const [productionCoordinator, setProductionCoordinator] = useState<any[]>(productionCoordinatorProps || []);
  const [officePa, setOfficePa] = useState<any[]>(officePaProps || []);

  const loadingLine = openLineProducer && options.length === 0;
  const loadingProduction = openProductionCoordinator && options.length === 0;
  const loadingOffice = openOfficePa && options.length === 0;
  const [loader, setLoader] = useState(false);

  // clean up field by clicking add prod coord
  const prodCoordRef = useRef<any>()
  const clearFieldProdCoord = () => {
    const buttonClean = prodCoordRef.current.querySelector('button')
    buttonClean.click();
  }

  // clean up field by clicking add officce pa
  const officePaRef = useRef<any>()
  const clearFieldOfficePa = () => {
    const buttonClean = officePaRef.current.querySelector('button')
    buttonClean.click();
  }

  const initialValues: NewProjectForm = {
    client_logo: urlLogo,
    company_id: companyId || '',
    project_name: projectName,
    num_project: numProject,
    start_date: startDate || new Date(),
    end_date: endDate || new Date(Date.now() + 1 * 24 * 60 * 60 * 1000),
    company_manager: areCompanyManager,
    product_manager: !!lineProducerProps || productionCoordinatorProps?.length > 0 || officePaProps?.length > 0,
  };

  const NewProjectSchema = yup.object().shape({
    client_logo: yup.string().nullable(),
    company_id: yup.string()
      .min(2, 'Too Short!')
      .max(50, 'Too Long!')
      .required('Required'),
    project_name: yup.string()
      .min(2, 'Too Short!')
      .max(50, 'Too Long!')
      .required('Required'),
    num_project: yup.string()
      .min(2, 'Too Short!')
      .max(40, 'Too Long!')
      .required('Required'),
    start_date: yup.date()
      .nullable(),
    end_date: yup.date()
      .nullable(),
    company_manager: yup.bool(),
    product_manager: yup.bool()
  });

  const formik = useFormik({
    initialValues,
    validationSchema: NewProjectSchema,
    onSubmit: async (variables) => {
      setLoader(true);
      const tempCompanyManager: any[] = [];
      const tempProjectManager: any[] = [];
      if (companyManagers.length > 0) {
        companyManagers.forEach((element) => {
          if (element.checked) {
            tempCompanyManager.push({
              user_id: element.id || element.user_id,
            })
          }
        });
      }
      if (lineProducer) {
        tempProjectManager.push({
          user_id: lineProducer?.id || lineProducer?.user_id,
          user_role: UserRoles.LINE_PRODUCER,
        });
      }
      if (productionCoordinator) {
        productionCoordinator.forEach((element) => {
          tempProjectManager.push({
            user_id: element?.id || element.user_id,
            user_role: UserRoles.PRODUCTION_COORDINATOR,
          });
        });
      }
      if (officePa) {
        officePa.forEach((element) => {
          tempProjectManager.push({
            user_id: element?.id || element.user_id,
            user_role: UserRoles.OFFICE_PA,
          });
        });
      }
      try {
        if (edit) {
          await updateProject({
            variables: {
              id: projectId,
              company_id: variables.company_id === 'null' ? null : variables.company_id,
              project_name: variables.project_name,
              num_project: variables.num_project,
              start_date: format(variables.start_date, formatDate),
              end_date: format(variables.end_date, formatDate),
              company_manager: tempCompanyManager,
              project_manager: tempProjectManager,
              client_logo: editLogo ? variables.client_logo : undefined,
            },
          }).then((respue) => {
            setAlertDescription({
              open: true,
              message: 'The project has been updated successfully',
              severity: 'success',
            });
            setUnsavedFlag(false);
          });
        } else {
          await createProject({
            variables: {
              company_id: variables.company_id === 'null' ? null : variables.company_id,
              project_name: variables.project_name,
              num_project: variables.num_project,
              start_date: format(variables.start_date, formatDate),
              end_date: format(variables.end_date, formatDate),
              company_manager: tempCompanyManager,
              project_manager: tempProjectManager,
              client_logo: variables.client_logo,
            },
          }).then((respue) => {
            setAlertDescription({
              open: true,
              message: 'The project has been created successfully',
              severity: 'success',
            });
            setUnsavedFlag(false);
          });
        }
        navigate('/');
      } catch (e) {
        console.error(e);
      }
      setLoader(false);
    },
  });

  const handleChangeCompanyManager = (manager: CompanyManager, index: number) => {
    const tempCompanyManager = cloneDeep(companyManagers);
    tempCompanyManager[index].checked = !manager.checked;
    setCompanyManagers(tempCompanyManager);
  };

  const onChangeHandle = async (value: string) => {
    getCompanyManager({
      variables: {
        name_or_email: value,
      },
    })
  };

  const addProduction = () => {
    const tempProductionCoordinator = cloneDeep(productionCoordinator);
    const addProductionValue = concat(tempProductionCoordinator, valueAutoProduction);
    setProductionCoordinator(addProductionValue);
    setValueAutoProduction(null);
  };

  const deleteProduction = (id: string) => {
    const tempProductionCoordinator = cloneDeep(productionCoordinator);
    const itemIndex = tempProductionCoordinator.findIndex((item) => item?.id === id);
    tempProductionCoordinator.splice(itemIndex, 1);
    setProductionCoordinator(tempProductionCoordinator);
  };

  const deleteOffice = (id: string) => {
    const tempOfficePa = cloneDeep(officePa);
    const itemIndex = tempOfficePa.findIndex((item) => item?.id === id);
    tempOfficePa.splice(itemIndex, 1);
    setOfficePa(tempOfficePa);
  };

  const addOffice = () => {
    const tempOfficePa = cloneDeep(officePa);
    const addOfficeValue = concat(tempOfficePa, valueAutoOffice);
    setOfficePa(addOfficeValue);
    setValueAutoOffice(null);
  };

  const onLoad = async (file: File) => {
    setEditLogo(true);
    const objectUrl = URL.createObjectURL(file)
    setImage(<img className="image-logo" src={objectUrl} alt="logo" />);
    getBase64(file)
      .then(async (logo) => {
        formik.setFieldValue('client_logo', logo);
      });
  };

  useEffect(() => {
    if (!openLineProducer && !openProductionCoordinator && !openOfficePa) {
      setOptions([]);
    }
  }, [openLineProducer, openProductionCoordinator, openOfficePa]);

  useEffect(() => {
    getCompanyList();
    if (companyId && companyId !== 'null') {
      formik.setFieldValue('company_id', companyId);
      companyInfo();
    }
  }, [companyId]);

  useEffect(() => {
    if (companyList) {
      if (loginState.company_id.get()) {
        setOptionsCompanyList(companyList.companyList as CompanyIInfo[]);
      } else {
        setOptionsCompanyList([{ id: 'null', company_name: 'My Project', email: 'MyProject@gmail.com' } as CompanyIInfo, ...companyList.companyList as CompanyIInfo[]])
        if (!edit) {
          formik.setFieldValue('company_id', 'null');
          setValueCompany({ id: 'null', company_name: 'My Project', email: 'MyProject@gmail.com' } as CompanyIInfo);
        }
      }
    }
  }, [companyList]);

  useEffect(() => {
    if (company && companyId !== 'null') {
      if (company.companyInfo?.id === myProject || edit) {
        setAreCompanyManager(true)
      } else {
        setAreCompanyManager(false)
      }
      setCompanyInfo(company.companyInfo as CompanyIInfo);
      if (changeCompany || !edit) {
        setCompanyManagers(company?.companyInfo?.company_managers as CompanyManager[])
      }
    }
    if (companyId === 'null') {
      setCompanyManagers([]);
    }
  }, [company]);

  useEffect(() => {
    setAreCompanyManager(false);
    companyManagers.forEach((element) => {
      if (element.checked) { setAreCompanyManager(true); }
    });
  }, [companyManagers]);

  useEffect(() => {
    formik.setFieldValue('company_manager', areCompanyManager);
  }, [areCompanyManager]);

  useEffect(() => {
    if (productionCoordinator.length > 0 || officePa.length > 0 || !!lineProducer || areCompanyManager) {
      formik.setFieldValue('product_manager', true);
    } else formik.setFieldValue('product_manager', false);
  }, [productionCoordinator, officePa, lineProducer, areCompanyManager]);

  useEffect(() => {
    if (listCompanyManagers) {
      const tempOptions = cloneDeep(listCompanyManagers.getCompanyManagerList || [{}]);
      if (lineProducer) {
        const itemIndex = tempOptions.findIndex((item) => item?.id === lineProducer.id || item?.id === lineProducer.user_id);
        if (itemIndex >= 0) tempOptions.splice(itemIndex, 1);
      }
      if (productionCoordinator.length > 0) {
        productionCoordinator.forEach((id) => {
          const itemIndex = tempOptions.findIndex((item) => item?.id === id.id || item?.id === id.user_id);
          if (itemIndex >= 0) tempOptions.splice(itemIndex, 1);
        });
      }
      if (officePa.length > 0) {
        officePa.forEach((id) => {
          const itemIndex = tempOptions.findIndex((item) => item?.id === id.id || item?.id === id.user_id);
          if (itemIndex >= 0) tempOptions.splice(itemIndex, 1);
        });
      }
      if (tempOptions.length <= 0) {
        tempOptions.push({})
      }
      setOptions(tempOptions as CompanyManager[]);
    }
  }, [listCompanyManagers]);

  usePrompt("Are you sure you want to exit before saving?", unsavedFlag);

  return (
    <>
      <Typography
        component="h1"
        variant="h2"
        sx={{
          mb: 2,
          fontWeight: 500,
        }}
      >
        {edit ? 'Project Details' : 'New Project'}
      </Typography>
      <FormControl
        fullWidth
        component="form"
        onSubmit={formik.handleSubmit}
      >
        <Grid
          item
          sx={{
            width: '150px',
            maxWidth: '90%',
            height: '150px',
            mb: 4,
          }}
        >
          <AddLogoCompany image={image} onLoad={onLoad} />
        </Grid>
        <Grid
          sx={{
            display: 'flex',
          }}
        >
          <Autocomplete
            id="company"
            sx={{
              width: '844px',
              maxWidth: '844px',
              display: 'flex',
            }}
            open={openCompany}
            options={optionsCompanyList}
            onOpen={() => {
              setOpenCompany(true);
            }}
            onClose={() => {
              setOpenCompany(false);
            }}
            renderOption={(props, option) => (
              <li {...props}>
                {option.company_name}
              </li>
            )}
            value={valueCompany}
            onChange={(event: any, newValue: CompanyIInfo | null | undefined) => {
              formik.setFieldValue('company_id', newValue?.id);
              setChangeCompany(true);
              setCompanyId(newValue?.id);
              setValueCompany(newValue);
              setUnsavedFlag(true);
            }}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={(option) => `${option.company_name}`}
            loading={loadingLine}
            renderInput={(params) => (
              <TextField
                required
                {...params}
                placeholder="Type a name of a company"
                onChange={(ev) => {
                  if (ev.target.value !== '' || ev.target.value !== null) {
                    onChangeHandle(ev.target.value);
                  }
                }}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loadingLine ? <CircularProgress color="primary" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        </Grid>
        <Grid
          sx={{
            display: 'flex',
            mt: 2
          }}
        >
          <TextField
            sx={{
              width: '414px',
              mr: 2
            }}
            required
            id="project_name"
            label="Project name"
            name="project_name"
            autoComplete="project_name"
            autoFocus
            value={formik.values.project_name}
            onChange={(event) => {
              formik.setFieldValue('project_name', event.target.value);
              setUnsavedFlag(true);
            }}
            error={formik.touched.project_name && Boolean(formik.errors.project_name)}
            helperText={formik.touched.project_name && formik.errors.project_name}
          />
          <TextField
            sx={{
              width: '414px',
            }}
            id="project_number"
            label="Project Number"
            required
            name="project_number"
            autoComplete="project_number"
            value={formik.values.num_project}
            onChange={(event) => {
              formik.setFieldValue('num_project', event.target.value);
              setUnsavedFlag(true);
            }}
            error={formik.touched.project_name && Boolean(formik.errors.project_name)}
            helperText={formik.touched.project_name && formik.errors.project_name}
          />
        </Grid>
        <Typography
          sx={{
            my: 1,
            fontWeight: '500',
          }}
          component="p"
          variant="body2"
        >
          Calendar
        </Typography>
        <Grid
          sx={{
            display: 'flex',
            mt: 1,
          }}
        >
          <LocalizationProvider
            dateAdapter={AdapterDateFns}
          >
            <DatePicker
              label="Start"
              value={formik.values.start_date}
              minDate={edit ? formik.values.start_date : new Date()}
              onChange={(value) => {
                formik.setFieldValue('start_date', value);
                setUnsavedFlag(true);
              }}
              renderInput={(params) => (
                <TextField
                  sx={{
                    mr: 2,
                  }}
                  id="start-date"
                  name="start_date"
                  autoComplete="start-date"
                  error={formik.touched.start_date && Boolean(formik.errors.start_date)}
                  helperText={formik.touched.start_date && formik.errors.start_date}
                  {...params}
                />
              )}
            />
          </LocalizationProvider>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="End"
              value={formik.values.end_date}
              minDate={formik.values.start_date}
              onChange={(value) => {
                formik.setFieldValue('end_date', value);
                setUnsavedFlag(true);
              }}
              renderInput={(params) => (
                <TextField
                  id="end-date"
                  name="end_date"
                  autoComplete="end-date"
                  error={formik.touched.end_date && Boolean(formik.errors.end_date)}
                  helperText={formik.touched.end_date && formik.errors.end_date}
                  {...params}
                />
              )}
            />
          </LocalizationProvider>
        </Grid>
        {
          (formik.values.company_id !== '' && formik.values.company_id !== myProject) && (
            <Grid>
              <Typography
                sx={{
                  my: 1,
                  mt: 2,
                  fontWeight: 500,
                }}
                component="p"
                variant="h4"
              >
                Company Managers
              </Typography>
              {companyManagers.length <= 0 && (
                <Typography
                  sx={{
                    mb: 2,
                    fontWeight: 300
                  }}
                  component="p"
                  variant="body2"
                >
                  No company managers added
                </Typography>
              )}
              {companyManagers.map((item, index) => (
                <Grid
                  key={item.id || item.user_id}
                  item
                  sx={{
                    width: '500px',
                    maxWidth: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    my: 2,
                  }}
                >
                  <Grid
                    item
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Avatar url={item.url_avatar} size={50} />
                    <Typography
                      sx={{
                        ml: 1,
                        textTransform: 'capitalize',
                      }}
                      component="p"
                      variant="h5"
                    >
                      {item.full_name}
                    </Typography>
                  </Grid>
                  <Switch
                    checked={item.checked}
                    onChange={() => {
                      handleChangeCompanyManager(item, index)
                      setUnsavedFlag(true);
                    }}
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
                </Grid>
              ))}
            </Grid>
          )
        }
        <Grid>
          <Typography
            sx={{
              my: 1,
              fontWeight: 500
            }}
            component="p"
            variant="h4"
          >
            Line producer
          </Typography>
          {lineProducer
            ? (
              <Grid
                item
                sx={{
                  width: '500px',
                  maxWidth: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  my: 2,
                }}
              >
                <Grid
                  item
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Avatar url={lineProducer.url_avatar} size={50} />
                  <Typography
                    sx={{
                      ml: 1,
                    }}
                    component="p"
                    variant="body1"
                  >
                    {lineProducer.full_name}
                  </Typography>
                </Grid>
                <IconButton
                  onClick={() => {
                    setLineProducer(undefined);
                  }}
                >
                  <Clear
                    sx={{
                      color: grey[500],
                      cursor: 'pointer',
                    }}
                    fontSize="small"
                  />
                </IconButton>
              </Grid>
            ) : (
              <Grid
                sx={{
                  width: '100%',
                  display: 'flex',
                  fontWeight: 500,
                  my: 2,
                }}
              >
                <Autocomplete
                  id="line-producer"
                  sx={{
                    width: '700px',
                    maxWidth: '90%',
                    mr: 1,
                    display: 'flex',
                  }}
                  open={openLineProducer}
                  options={options}
                  onOpen={() => {
                    setOpenLineProducer(true);
                  }}
                  onClose={() => {
                    setOpenLineProducer(false);
                  }}
                  renderOption={(props, option) => (
                    <li {...props}>
                      {option.full_name}
                    </li>
                  )}
                  onChange={(event: any, newValue: CompanyManager | null | undefined) => {
                    setValueAutoLine(newValue)
                    setUnsavedFlag(true);
                  }}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  getOptionLabel={(option) => `${option.email}  ${option.full_name}`}
                  loading={loadingLine}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Type a name or a co-worker’s email"
                      onChange={(ev) => {
                        if (ev.target.value !== '' || ev.target.value !== null) {
                          onChangeHandle(ev.target.value);
                        }
                      }}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {loadingLine ? <CircularProgress color="primary" size={20} /> : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
                <Button
                  type="submit"
                  variant="contained"
                  disabled={!valueAutoLine}
                  onClick={() => {
                    setLineProducer(valueAutoLine);
                    setValueAutoLine(undefined);
                  }}
                  sx={{
                    width: '135px',
                  }}
                >
                  Add
                </Button>
              </Grid>
            )}
        </Grid>
        <Typography
          sx={{
            my: 1,
            fontWeight: 500
          }}
          component="p"
          variant="h4"
        >
          Production coordinator
        </Typography>
        <Grid
          sx={{
            width: '100%',
            display: 'flex',
            my: 2,
          }}
        >
          <Autocomplete
            key='prodCoor'
            id="production-coordinator"
            ref={prodCoordRef}
            sx={{
              width: '700px',
              maxWidth: '90%',
              mr: 1,
              display: 'flex',
            }}
            open={openProductionCoordinator}
            options={options}
            onOpen={() => {
              setOpenProductionCoordinator(true);
            }}
            onClose={() => {
              setOpenProductionCoordinator(false);
            }}
            renderOption={(props, option) => (
              <li {...props}>
                {option.full_name}
              </li>
            )}
            onChange={(event: any, newValue: CompanyManager | null | undefined) => {
              setValueAutoProduction(newValue as CompanyManager)
              setUnsavedFlag(true);
            }}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={(option) => `${option.email}  ${option.full_name}`}
            loading={loadingProduction}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Type a name or a co-worker’s email"
                onChange={(ev) => {
                  if (ev.target.value !== '' || ev.target.value !== null) {
                    onChangeHandle(ev.target.value);

                  }
                }}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loadingProduction ? <CircularProgress color="primary" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
          <Button
            type="submit"
            variant="contained"
            disabled={!valueAutoProduction}
            onClick={() => {
              addProduction();
              clearFieldProdCoord();
            }}
            sx={{
              width: '135px',
              fontWeight: 500,
            }}
          >
            Add
          </Button>
        </Grid>
        {productionCoordinator.length > 0 && (
          <>
            {productionCoordinator.map((manager) => (
              <Grid
                key={manager.id}
                item
                sx={{
                  width: '500px',
                  maxWidth: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  my: 2,
                }}
              >
                <Grid
                  item
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Avatar url={manager.url_avatar} size={50} />
                  <Typography
                    sx={{
                      ml: 1,
                    }}
                    component="p"
                    variant="body1"
                  >
                    {manager.full_name}
                  </Typography>
                </Grid>
                <IconButton
                  onClick={() => {
                    deleteProduction(manager.id);
                  }}
                >
                  <Clear
                    sx={{
                      color: grey[500],
                      cursor: 'pointer',
                    }}
                    fontSize="small"
                  />
                </IconButton>
              </Grid>
            ))}
          </>
        )}
        <Typography
          sx={{
            my: 1,
            fontWeight: 500
          }}
          component="p"
          variant="h4"
        >
          Office PA
        </Typography>
        <Grid
          sx={{
            width: '100%',
            display: 'flex',
            my: 2,
          }}
        >
          <Autocomplete
            key='officePa'
            id="office-pa"
            ref={officePaRef}
            sx={{
              width: '700px',
              maxWidth: '90%',
              mr: 1,
              display: 'flex',
            }}
            open={openOfficePa}
            options={options}
            onOpen={() => {
              setOpenOfficePa(true);
            }}
            onClose={() => {
              setOpenOfficePa(false);
            }}
            renderOption={(props, option) => (
              <li {...props}>
                {option.full_name}
              </li>
            )}
            onChange={(event: any, newValue: CompanyManager | null | undefined) => {
              setValueAutoOffice(newValue as CompanyManager)
              setUnsavedFlag(true);
            }}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={(option) => `${option.email}  ${option.full_name}`}
            loading={loadingOffice}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Type a name or a co-worker’s email"
                onChange={(ev) => {
                  if (ev.target.value !== '' || ev.target.value !== null) {
                    onChangeHandle(ev.target.value);
                  }
                }}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loadingOffice ? <CircularProgress color="primary" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
          <Button
            type="submit"
            variant="contained"
            disabled={!valueAutoOffice}
            onClick={() => {
              addOffice();
              clearFieldOfficePa();
            }}
            sx={{
              width: '135px',
              fontWeight: 500
            }}
          >
            Add
          </Button>
        </Grid>
        {officePa.length > 0 && (
          <>
            {officePa.map((manager) => (
              <Grid
                key={manager.id}
                item
                sx={{
                  width: '500px',
                  maxWidth: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  my: 2,
                }}
              >
                <Grid
                  item
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Avatar url={manager.url_avatar} size={50} />
                  <Typography
                    sx={{
                      ml: 1,
                    }}
                    component="p"
                    variant="body1"
                  >
                    {manager.full_name}
                  </Typography>
                </Grid>
                <IconButton
                  onClick={() => {
                    deleteOffice(manager.id);
                  }}
                >
                  <Clear
                    sx={{
                      color: grey[500],
                      cursor: 'pointer',
                    }}
                    fontSize="small"
                  />
                </IconButton>
              </Grid>
            ))}
          </>
        )}
        <Button
          type="submit"
          variant="contained"
          disabled={!(formik.isValid) || loader}
          sx={{
            mt: 3,
            mb: 2,
            float: 'right',
            width: '200px',
            fontWeight: 500
          }}
        >
          {loader ? (
            <CircularProgress color="primary" size={25} />
          ) : (
            labelButton
          )}
        </Button>
      </FormControl>
    </>
  );
}

export default ViewProjectPage;
